<template>
    <v-flex xs12 lg2 ma-1>
        <v-card>
            <v-card-title>
                Create Invoice
            </v-card-title>

            <v-card-text>
               
                <v-layout column>
                    <v-btn disabled>Annual Fee Invoice</v-btn>
                    <v-btn disabled>Manual Invoice</v-btn>
                    <v-btn disabled>Arrears Invoice</v-btn>
                </v-layout>
                
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    /**
     * Display buttons linking through to accounts invoice creation pages
     */
    export default {
        props:[],

        data: function() {
            return {
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){},

        methods: {},

        computed: {}
    }
</script>
